export function isEmpty(value) {
    return (value === undefined ||
        (Array.isArray(value) && value.length === 0) ||
        (typeof value === 'string' && value.trim().length === 0));
}
//# sourceMappingURL=utils.js.map